import React, { Component } from 'react';
import * as commonActions from '../../../../../../app/common/common.action';
import { getUsuarioLocalStorage } from '../../../../../../localStorage.util';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../material.action';
import ChecklistModalPage from './checklist-modal.page';
import WebapiCommon from '@common/util/webapi.common';
import IntlMessage from '../../../../../../helpers/intlMessage';

class ChecklistModalContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      itens: [],
      disableSalvar: true,
      selectOptions: []
    };
  }

  componentDidMount() {
    if (this.props.perguntas) {
      this.setState({
        itens: this.props.perguntas,
      });
    } else {
      this.props.commonActions.showFadeCarregando(true);
      WebapiCommon.getSelectOptionsChecklist().then((res)=>{
        this.setState({selectOptions: res.data});
      });
      WebapiCommon.getItensChecklist(
        this.props.detalhes.exameId,
        this.props.detalhes.pacienteId
      ).then((result) => {
        if (result.length > 0) {
          var itens = result.map((item) => {
            return {
              ...item,
              ...{ value: null },
              ...{ ref: React.createRef() },
            };
          });
          this.setState({
            itens,
            questionarioId: result[0].idQuestionario,
          });

          this.props.commonActions.showFadeCarregando(false);
        } else {
          this.props.commonActions.showFadeCarregando(false);
          this.props.commonActions.bloquearRecebimento(false);
          this.props.commonActions.showAlerta(
            'alerta',
            <IntlMessage id = "dashboards.examDetail.noItems"/>,
            2500
          );
          this.props.toggle();
        }
      });
    }
  }

  render() {
    return (
      <ChecklistModalPage
        selectOptions={this.state.selectOptions}
        itens={this.state.itens}
        isOpen={this.props.isOpen}
        toggle={this.props.toggle}
        //altura={this.props.altura}
        readonly={this.props.readonly}
        disableSalvar={this.state.disableSalvar}
        salvar={this.salvar.bind(this)}
        salvarRespostaPergunta={this.salvarRespostaPergunta.bind(this)}
      />
    );
  }

  salvar() {
    var bloqueio = 0;
    var respostas = this.state.itens.map((item) => {
      if (item.value.impeditiva) {
        bloqueio += 1;
      }

      return {
        perguntaId: item.id,
        respostaId: item.tipoResposta == 'select' ? item.value.value : 0,
        descricaoResposta:item.tipoResposta == 'select' ? item.value.label : item.value,
        tipoResposta:item.tipoResposta
      };
    });

    const usuarioLocal = getUsuarioLocalStorage();
    WebapiCommon.gravarRespostaChecklist(
      this.props.detalhes.laudo,
      usuarioLocal.usuarioId,
      this.state.questionarioId,
      respostas
    );

    if (bloqueio > 0) {
      this.props.commonActions.showFadeCarregando(false);
      this.props.commonActions.bloquearRecebimento(true);
      this.props.toggle();
      this.props.commonActions.showAlerta(
        'alerta',
        <IntlMessage id = "dashboards.examDetail.receiptMaterialBlocked"/>,
        2500
      );
    } else {
      this.props.commonActions.showFadeCarregando(false);
      this.props.commonActions.bloquearRecebimento(false);
      this.props.toggle();
      this.props.commonActions.showAlerta(
        'sucesso',
        <IntlMessage id = "dashboards.examDetail.questionnaireSuccessfully"/>,
        2500
      );
    }
  }

  enableSalvar() {
    var exist = this.state.itens.find(
      (item) => item.value === null
    );

    if (!exist) this.setState({ disableSalvar: false });
  }

  salvarRespostaPergunta(pergunta, resposta) {
    var itens = this.state.itens;
    itens.map((item) => {
      if (item.id === pergunta) {
        item.value = resposta;
      }
      return item;
    });
    this.setState({
      itens,
    });
    this.enableSalvar();
  }
}

const mapStateToProps = (state) => {
  return {
    detalhes: state.commonReducer.detalhes,
    listagem: state.commonReducer.listagem,
    etapa: state.commonReducer.etapa,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators(actions, dispatch),
    commonActions: bindActionCreators(commonActions, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ChecklistModalContainer);



// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/material/tabs/checklist/checklist-modal.container.js